import React from 'react';
import styled from 'styled-components/macro';
import I18n from '../../../helper/Localization';
import { Label } from 'office-ui-fabric-react/lib/Label';
import { Dropdown } from 'office-ui-fabric-react/lib/Dropdown';
import { BasicDatePicker } from '../../BasicDatePicker';

const InputHeadlineContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
`;

const InputContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    min-height: 75px;
`;

const InputContainerSmall = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`;

const InfoTextWrapper = styled.div`
    display: flex;
    word-wrap: break-word;
    max-width: 300px;
`;

/**
 * Reusable component for manual test status and date selection.
 */
export const ManualTestStatusDialog = ({
    resultLeft,
    resultRight,
    dateExecuted,
    onResultLeftChange,
    onResultRightChange,
    onDateExecutedChange
}) => {
    const dropdownOptions = [
        { key: 'success', text: I18n.get().t('ManualTestDialog_Success') },
        { key: 'fail', text: I18n.get().t('ManualTestDialog_Fail') },
    ];

    return (
        <>
            <InputHeadlineContainer>
                <Label>{I18n.get().t('ManualTestDialog_Status')}</Label>
            </InputHeadlineContainer>
            <InfoTextWrapper>{I18n.get().t('ManualTestDialog_Status_Info')}</InfoTextWrapper>
            <InputContainer>
                <Dropdown
                    label={I18n.get().t('ManualTestDialog_Left_Result')}
                    options={dropdownOptions}
                    required
                    style={{ minWidth: '187px' }}
                    selectedKey={resultLeft === true ? 'success' : resultLeft === false ? 'fail' : undefined}
                    onChange={(_, newValue) => {
                        if (newValue.key === 'success') {
                            onResultLeftChange(true);
                        } else {
                            onResultLeftChange(false);
                        }
                    }}
                />
                <Dropdown
                    label={I18n.get().t('ManualTestDialog_Right_Result')}
                    options={dropdownOptions}
                    required
                    style={{ marginLeft: 'auto', minWidth: '187px' }}
                    selectedKey={resultRight === true ? 'success' : resultRight === false ? 'fail' : undefined}
                    onChange={(_, newValue) => {
                        if (newValue.key === 'success') {
                            onResultRightChange(true);
                        } else {
                            onResultRightChange(false);
                        }
                    }}
                />
            </InputContainer>
            <InputHeadlineContainer>
                <Label>{I18n.get().t('ManualTestDialog_Testdate')}</Label>
            </InputHeadlineContainer>
            <InputContainerSmall>
                <BasicDatePicker defaultValue={dateExecuted} onChangeCallback={onDateExecutedChange} maxDate={new Date()} />
            </InputContainerSmall>
        </>
    );
};